import React from 'react';
import { Box, Flex, SpinnerWithFailed } from '@fullstory/components';
import { CustomField, prettifyVarType } from '@fullstory/search-vars';
import { APILabel } from '../APILabel';
import { propertiesFailedToLoadRetry } from '../../constants';

export interface APIPropertyLabelsProps {
  properties: CustomField[];
  loading: boolean;
  failed: boolean;
  onFailedRetry: () => void;
}

export const APIPropertyLabels: React.FC<APIPropertyLabelsProps> = ({
  properties,
  loading,
  failed,
  onFailedRetry,
}) => {
  if (loading || failed) {
    return (
      <SpinnerWithFailed
        failed={failed}
        onFailedRetry={onFailedRetry}
        failedMessage={propertiesFailedToLoadRetry}
      />
    );
  }
  return (
    <>
      {properties.map((property, i) => (
        <Box marginBottom={8} key={`${property.ident}${property.varType}`}>
          <Flex justifyContent="flex-start" alignItems="flex-start">
            <Box marginRight={8}>
              <APILabel text={property.ident} />
            </Box>
            <APILabel text={prettifyVarType(property.varType)} />
          </Flex>
        </Box>
      ))}
    </>
  );
};
